import useScriptFlag from '@/hooks/useScriptFlag';
import { useEffect, useRef } from 'react';

export default function AdTruvid() {
  const hasRendered = useRef(false);
  const shouldRenderAds = useScriptFlag({ adFlag: 'truvid' });

  const appendScript = () => {
    if (hasRendered.current) return;

    const existingComponent = document.getElementById('truvidPos');
    if (!existingComponent) return;

    const existingScript = document.getElementById('truvid');
    if (existingScript) return;

    const script = document.createElement('script');
    script.id = 'truvid';
    script.setAttribute('delayedSrc', 'https://cnt.trvdp.com/js/455/9332.js');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;

    const truvidParent = document.getElementById('truvidPos');
    truvidParent.appendChild(script);

    hasRendered.current = true;

    setTimeout(() => {
      script.setAttribute('src', script.getAttribute('delayedSrc'));
    }, 5000);
  };

  useEffect(() => {
    if (shouldRenderAds) appendScript();
  }, []);

  return <div id="truvidPos" className="truvidPos" />;
}
